import { render } from "./CategoryMenu.vue?vue&type=template&id=40d7bdeb&scoped=true"
import script from "./CategoryMenu.vue?vue&type=script&lang=js"
export * from "./CategoryMenu.vue?vue&type=script&lang=js"

import "./CategoryMenu.vue?vue&type=style&index=0&id=40d7bdeb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d7bdeb"]])

export default __exports__